import MuiAlert, { AlertProps } from '@mui/material/Alert'
import * as React from 'react'
import { ForwardedRef } from 'react'

const Alert = React.forwardRef((props: AlertProps, ref?: ForwardedRef<HTMLDivElement> | null) => {
  return <MuiAlert ref={ref} {...props} />
})

export default Alert
